var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.activeKPI),function(k){return _c('v-flex',{attrs:{"xs6":"","md4":""}},[_c('value-box',{attrs:{"unit":k.unit,"value":k.kpi_value,"icon":"","title":k.kpi_name}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }